// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__184z2","footer":"Form_footer__1Lpaj"};